<template>
  <div class="page-verified">
    <!-- <div class="group">
      <div class="page-wrapper">
        <div class="verify-your-code-wrapper">
          <div class="verify-your-code">Verify Your Code</div>
        </div>
      </div>
    </div> -->
    <p class="verifyDesc">{{ codeDesc }}</p>
    <div :class="'codeDiv-wrap ' + (viewType == 'm' ? ' MobileSmscode' : '')">
      <div class="codeDiv codegz" :class="wrongcode ? 'red_field' : ''">
        <div v-for="(item, idx) in 6" :key="item">
          <input
            type="text"
            v-model="verifiedCode[idx]"
            @input="(event) => handleInput(idx, event)"
            :id="'inputSigncode' + idx"
            :ref="'inputSigncode' + idx"
          />
        </div>
      </div>
      <div :class="'codeDiv btn-group ' + (viewType == 'm' ? ' btn-mobile' : '')">
        <div class="verifybtn" @click="resend_code">Resend Code</div>
        <div class="verifybtn" @click="verify">{{ verifyTxt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Request from '@/services/Request'

export default {
  props: ['code', 'viewType', 'codeDesc'],
  emits: ['signDone', 'resendCode'],
  data() {
    return {
      verifiedCode: ['', '', '', '', '', ''],
      verifyTxt: 'Verify',
      curfocus: 0,
      wrongcode: false,
      verifying: false
    }
  },
  watch: {},
  mounted() {},
  methods: {
    handleInput(idx, event) {
      const input = this.verifiedCode[idx].replace(/[^0-9]/g, '')
      if (input.length > 1) {
        input.split('').forEach((digit, i) => {
          if (idx + i < 6) this.verifiedCode[idx + i] = digit
        })
      } else {
        this.verifiedCode[idx] = input
      }
      if (this.verifiedCode[idx] !== '' && idx < 5) {
        this.$refs['inputSigncode' + (idx + 1)][0].focus()
      }
      const target = event.target
      if (target.value.length > 0 && idx < this.verifiedCode.length - 1) {
        const nextInput = this.$refs[`inputSigncode${idx + 1}`]
        if (nextInput && typeof nextInput.focus === 'function')
        {
          nextInput.focus()
        }
      }
    },
    // The code is no longer sent to the browser: verify it server-side (the payment submit
    // is refused until this succeeded in the same session).
    verify() {
      const comfCode = this.verifiedCode.join('')
      if (comfCode.length !== 6 || this.verifying) {
        this.setVerified(false)
        return
      }
      this.verifying = true
      new Request().webPost(
        { code: comfCode },
        (res) => {
          this.verifying = false
          this.setVerified(!!res?.success)
        },
        'account/account/verifyCode',
        () => {
          this.verifying = false
          this.setVerified(false)
        }
      )
    },
    setVerified(verified) {
      this.verifyTxt = verified ? 'Verified' : 'Verify'
      this.wrongcode = !verified
      this.$emit('signDone', verified ? 1 : 0)
    },
    resend_code() {
      this.verifiedCode = ['', '', '', '', '', '']
      this.verifyTxt = 'Verify'
      this.wrongcode = false
      this.$emit('signDone', 0)
      this.$emit('resendCode', 0)
    }
  }
}
</script>

<style scoped lang="scss">
.red_field {
  border: 1px solid red;
  border-radius: 10px;
}
.page-verified {
  align-items: center;
  /* display: flex; */
  flex-direction: column;
  gap: 1.2rem;
  position: relative;
}

.codeDiv-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  border-radius: 0.8rem;
  border: 0.1rem solid #d9d9d9;
  background: #fff;
  padding: 1.6rem;
  .codegz {
    width: 30rem !important;
  }
  .btn-group {
    width: 30rem !important;
    display: flex;
    justify-content: space-between;
  }
  .btn-mobile {
    width: 100% !important;
  }
}
.page-verified .group {
  height: 3rem;
  position: relative;
}
.page-verified .page-wrapper {
  height: 3rem;
}
.page-verified .verify-your-code-wrapper {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  gap: 2.8rem;
  position: relative;
}

.page-verified .verify-your-code {
  font-size: 2rem;
  font-weight: 700;
  height: 3rem;
  position: relative;
  text-align: center;
}

.page-verified .verifyDesc {
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2.2rem;
  text-align: left;
  color: #333;
  margin: 2.4rem 0 0.8rem;
}

.page-verified .codeDiv {
  width: 95%;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
}

.page-verified .codeDiv input {
  background: #fbfbfb;
  border: 0.1rem solid #cccccc;
  border-radius: 0.8rem;
  height: 4.3rem;
  width: 4rem;
  font-size: 1.8rem;
  font-weight: 700;
  padding: 0.6rem;
  text-align: center;
}

.page-verified .overlap-group {
  background-color: #fbfaf7;
  border: 0.1rem solid;
  border-color: #f1f0eb;
  border-radius: 0.8rem;
  box-shadow: 0rem 0.4rem 1.22rem #d5abf7;
  height: 4.3rem;
  left: 5.2rem;
  position: absolute;
  top: 0;
  width: 4rem;
}

.page-verified .verifybtn {
  font-size: 1.6rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: normal;
  margin: 0.5rem;
  align-items: center;
  border-radius: 1.5rem;
  justify-content: center;
  padding: 0.8rem 1rem 0.8rem;
  position: relative;
  color: #fff;
  cursor: pointer;

  color: #fff;
  font-family: Poppins;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.4rem;
  display: flex;
  // width: 13.3rem;
  padding: 1rem 2.4rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 2.8rem;
  background: #4f6f52;
}
.page-verified .MobileSmscode {
  flex-wrap: wrap;
}
.page-verified .MobileSmscode .btn-group {
  margin-top: 2rem;
  justify-content: flex-end;
}
</style>
